import { apiSlice } from "features/api/apiSlice";

const updateUser = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    updateUser: build.mutation({
      query: (data) => ({
        url: "/users/me",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) {
          return ["User"];
        }
      },
    }),
  }),
});

export const { useUpdateUserMutation } = updateUser;
